import React, { useEffect, useState } from "react";
import './Navbar.css';
import { useDispatch } from "react-redux";
import { getDefaultSettings } from "../Redux/actions/defaultSettingsActions";
import "../Pages/ProjectV2/Project_Navbar/Navbar_1.css";
import DashSetting from "../Pages/Setting/DashSetting";
import { New_ScrollX2025, scrollxLogo, SX_dashboard_Help_icon, user_2 } from "../assets/icons/index";
import { Link } from "react-router-dom";
import Setting from "../Pages/Setting/Setting";

export default function NavBar() {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const [isSettingOpen, setIsSettingOpen] = useState(false);

  useEffect(() => {
    fetchProjectSettings();
  }, []);

  const fetchProjectSettings = () => {
    dispatch(getDefaultSettings());
  };

  const getUserInitials = () => {
    // console.log("userInfo:", userInfo); // Debugging output
  
    const firstName = userInfo?.firstName?.trim() || "";
    // const lastName = userInfo?.lastName?.trim() || "";
  
    if (firstName) {
      return `${firstName.charAt(0).toUpperCase()}`;
    }
    return "U"; // Default initial if no name is available
  };
  
  const getBackgroundColor = () => {
    const initials = getUserInitials(); // Get initials
    const firstLetter = initials.charAt(0); // Extract first letter
  
    // console.log("First Letter for Color:", firstLetter); // Debugging
  
    const colors = {
      A: "#413CAA", B: "#413CAA", C: "#413CAA", D: "#413CAA", E: "#413CAA",
      F: "#413CAA", G: "#413CAA", H: "#413CAA", I: "#413CAA", J: "#413CAA",
      K: "#413CAA", L: "#413CAA", M: "#413CAA", N: "#413CAA", O: "#413CAA",
      P: "#413CAA", Q: "#413CAA", R: "#413CAA", S: "#413CAA", T: "#413CAA",
      U: "#413CAA", V: "#413CAA", W: "#413CAA", X: "#413CAA", Y: "#413CAA",
      Z: "#413CAA"
    };
  
    return colors[firstLetter] || "#413CAA"; // Default color if not found
  };

  return (
    <>   
      <nav className="w-full Pro_navbarDash  flex flex-wrap items-center justify-between text-slate-200 focus:text-sly-700 drop-shadow-2xl">
        <div className="w-full h-full flex flex-wrap items-center justify-between pl-[2.43%] pr-[2%]">

        <div className="w-[15%] h-full flex  items-center">
          <img className="w-[35px] " src={New_ScrollX2025} />
          <span className="ml-[10px] Syne700 text-xl tracking-wide ">ScrollX.io</span> 
        </div>

        <div className="w-[15%] flex justify-center items-center">
          <h1 className="manrope-600 text-[15px] text-white ">Dashboard</h1>
        </div>

        <div className="w-[15%] flex justify-end items-center">
          <div className="mr-[20px] manrope-600 text-[15px]  text-white">
            <Link to="/dashboard/myrenders"><h2>My Renders </h2></Link>
          </div>
          {/* <div><img className="w-[30px] mr-[20px]" src={SX_dashboard_Help_icon} alt="" /></div> */}

          <button className="w-[35px] h-[35px] rounded-full" onClick={() => setIsSettingOpen(true)} style={{backgroundColor: getBackgroundColor()}}>
            <div className="flex justify-center items-center text-white text-xl manrope-600 w-[35px] h-[35px] rounded-full ">
              <span className="manrope-600 text-white text-xl text-center ">{getUserInitials()}</span>
            </div>
          </button>
          </div>
        </div>  
      </nav>
      {/* <DashSetting isSettingOpen={isSettingOpen} setIsSettingOpen={setIsSettingOpen}/> */}
      <Setting isSettingOpen={isSettingOpen} setIsSettingOpen={setIsSettingOpen}/>

      
    </>
  );
}